import { useState, useEffect } from 'react';
import { Segment, Grid, Icon, Image, Divider, Header, Loader, Table } from 'semantic-ui-react';
import { getCommonAPI } from 'hpp-fe-common';

function PartnerVerify({ partnerVerifyData }) {
    const [partnerImage, setPartnerImage] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (partnerVerifyData?.partnerIDImageFileKey) {
            fetchPartnerImage(partnerVerifyData.partnerIDImageFileKey);
        }
    }, [partnerVerifyData?.partnerIDImageFileKey]);


    const fetchPartnerImage = async (imageURLKey) => {
        try {
            setLoading(true);

            const { data } = await getCommonAPI().get(`/api_v1/files/partner-image?key=${imageURLKey}`);

            if (data.error) {
                setError(data.errorMessage);
            } else {
                setPartnerImage(data.previewUrl);
            }
        } catch (err) {
            setError('Failed to load image. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Segment raised style={{ maxWidth: "500px", margin: "auto", padding: "25px", borderRadius: "12px", backgroundColor: "#fff" }}>
            {/* Partner Profile Section */}
            <Grid textAlign="center">
                <Grid.Row>
                    {loading ? (
                        <Loader active inline="centered" size="large" />
                    ) : error ? (
                        <Image
                            src="https://via.placeholder.com/200"
                            width={200}
                            height={200}
                            circular
                            centered
                            style={{ border: "2px solid #ddd", padding: "5px", backgroundColor: "#f9f9f9" }}
                        />
                    ) : (
                        <Image
                            src={partnerImage}
                            width={200}
                            height={200}
                            circular
                            centered
                            style={{ border: "2px solid #ddd", padding: "5px", backgroundColor: "#f9f9f9" }}
                        />
                    )}
                </Grid.Row>

                <Grid.Row>
                  
                    <Header as="h2" style={{ marginTop: '10px', color: '#333', fontWeight: 'bold' }}>
                        <Icon name="check circle" color="green" />
                        Verified 
                    </Header>
                    <p style={{ fontSize: "14px", color: "#666", marginTop: "5px" }}>
                        This is an <strong style={{ color: "#C8102E" }}>Authorized Hikvision Partner</strong>.
                    </p>
                </Grid.Row>
            </Grid>

            <Divider style={{ borderTop: "2px solid #C8102E" }} />

            {/* Partner Details Section */}
            <Segment basic>
                <Table celled padded style={{ border: "1px solid #ddd", backgroundColor: "#f9f9f9" }}>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell textAlign="center" style={{ backgroundColor: "#fff" }}>
                                <Icon name="user circle" size="large" color="red" />
                            </Table.Cell>
                            <Table.Cell>
                                <strong style={{ color: "#C8102E" }}>Partner Name</strong>
                                <br />
                                {partnerVerifyData?.firstName + " " + partnerVerifyData?.lastName || "N/A"}
                            </Table.Cell>
                        </Table.Row>

                        <Table.Row>
                            <Table.Cell textAlign="center" style={{ backgroundColor: "#fff" }}>
                                <Icon name="building" size="large" color="red" />
                            </Table.Cell>
                            <Table.Cell>
                                <strong style={{ color: "#C8102E" }}>Company Name</strong>
                                <br />
                                {partnerVerifyData?.companyName || "N/A"}
                            </Table.Cell>
                        </Table.Row>

                        <Table.Row>
                            <Table.Cell textAlign="center" style={{ backgroundColor: "#fff" }}>
                                <Icon name="id card outline" size="large" color="red" />
                            </Table.Cell>
                            <Table.Cell>
                                <strong style={{ color: "#C8102E" }}>NIC</strong>
                                <br />
                                {partnerVerifyData?.nic || "N/A"}
                            </Table.Cell>
                        </Table.Row>

                        <Table.Row>
                            <Table.Cell textAlign="center" style={{ backgroundColor: "#fff" }}>
                                <Icon name="barcode" size="large" color="red" />
                            </Table.Cell>
                            <Table.Cell>
                                <strong style={{ color: "#C8102E" }}>Hikvision ID</strong>
                                <br />
                                {partnerVerifyData?.hikID || "N/A"}
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </Segment>
        </Segment>
    );
}

export default PartnerVerify;

